var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { HttpClient } from "@angular/common/http";
import { EventsService } from "app/lib/EventsService";
import { BaseComponent } from "app/views/base.component";
import { HelperService } from "app/lib/helper.service";
import { ChartParams } from "../../views/chart/chart.component";
import { SitesService } from "../sites.service";
import { mergeFilterParams } from "../../lib/lib";
var colors = {
    addThisShareBar: 'rgb(31, 119, 180)',
    googleCounter: 'rgb(255, 127, 14)',
    stages: 'rgb(44, 160, 44)',
    timeline: 'rgb(214, 39, 40)',
    uSocial: 'rgb(148, 103, 189)',
    yandexCounter: 'rgb(140, 86, 75)',
    audio: 'rgb(31, 119, 180)',
    downloadFile: 'rgb(255, 127, 14)',
    slideshare: 'rgb(44, 160, 44)',
    video: 'rgb(214, 39, 40)',
    backCall: 'rgb(31, 119, 180)',
    contacts: 'rgb(255, 127, 14)',
    feedBack: 'rgb(44, 160, 44)',
    jivosite: 'rgb(214, 39, 40)',
    liveChat: 'rgb(148, 103, 189)',
    mailchimp: 'rgb(140, 86, 75)',
    maps: 'rgb(227, 119, 194)',
    bloquote: 'rgb(31, 119, 180)',
    customHtml: 'rgb(255, 127, 14)',
    goods: 'rgb(44, 160, 44)',
    uCard: 'rgb(30, 129, 176)',
    googlesearch: 'rgb(214, 39, 40)',
    newsInformer: 'rgb(148, 103, 189)',
    price: 'rgb(140, 86, 75)',
    review: 'rgb(227, 119, 194)',
    table: 'rgb(127, 127, 127)',
    timer: 'rgb(188, 189, 34)',
    ucalc: 'rgb(23, 190, 207)',
    weather: 'rgb(31, 119, 180)',
    yandexSearch: 'rgb(255, 127, 14)',
    border: 'rgb(0, 255, 0)',
    uSpacer: 'rgb(255, 127, 14)',
    uButton: 'rgb(31, 119, 180)',
    gallery: 'rgb(255, 127, 14)',
    header: 'rgb(44, 160, 44)',
    uIcon: 'rgb(214, 39, 40)',
    imagezoom: 'rgb(148, 103, 189)',
    uImage: 'rgb(52, 216, 200)',
    sliderWysiwyg: 'rgb(140, 86, 75)',
    wysiwyg: 'rgb(227, 119, 194)',
    ecwid: 'rgb(31, 119, 180)',
    productCard: 'rgb(255, 127, 14)',
    facebookLikeBox: 'rgb(31, 119, 180)',
    instagram: 'rgb(255, 127, 14)',
    odnoklassnikiLikeBox: 'rgb(44, 160, 44)',
    pinterest: 'rgb(214, 39, 40)',
    social: 'rgb(148, 103, 189)',
    socialGroups: 'rgb(140, 86, 75)',
    twitterLikeBox: 'rgb(227, 119, 194)',
    uMenu: 'rgb(200, 200, 50)',
    uSeparator: 'rgb(133, 66, 99)',
    uSpoiler: 'rgb(12, 166, 200)',
};
var WidgetReportComponent = /** @class */ (function (_super) {
    __extends(WidgetReportComponent, _super);
    function WidgetReportComponent(eventsService, activatedRoute, translate, router, filter, http, helper, siteService) {
        var _this = _super.call(this, eventsService, siteService, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.filter = filter;
        _this.http = http;
        _this.helper = helper;
        _this.siteService = siteService;
        _this.charts = [];
        _this.stats = [];
        _this.column = 'widgetAddCount';
        _this.oldWidgets = ['icon', 'mainmenu', 'spacer', 'button', 'border'];
        _this.widgetList = [];
        _this.totalCount = 0;
        _this.addFilterParams = {
            userType: 'user',
            isUserCharts: true,
            dateFilters: ['dateWidgetAdd', 'dateCreated', 'dateSiteCreated']
        };
        _this.chartsCategory = [
            'main',
            'structure',
            'content',
            'shop',
            'media',
            'contacts',
            'social',
            'other'
        ];
        _this.chartLoader = false;
        _this.listLoader = false;
        _this.countLoader = false;
        return _this;
    }
    WidgetReportComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCharts()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getList()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WidgetReportComponent.prototype.getCharts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, _i, _a, chartCategory, charts, chartData, labels, options;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        me = this;
                        me.charts = [];
                        me.chartLoader = true;
                        _i = 0, _a = me.chartsCategory;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        chartCategory = _a[_i];
                        return [4 /*yield*/, me.siteService.widget.chart(mergeFilterParams(me.filter.filterParams, { chartCategory: chartCategory, })).toPromise()];
                    case 2:
                        charts = (_b.sent()).charts;
                        chartData = new ChartParams(), labels = charts.reduce(function (obj, line) {
                            if (line[0] !== 'x' && !obj[line[0]]) {
                                obj[line[0]] = me.translate.__("widgets." + line[0] + ".name");
                                if (me.oldWidgets.includes(line[0].toString())) {
                                    obj[line[0]] += ' old';
                                }
                            }
                            return obj;
                        }, {
                            gallery2: me.translate.__A("widget.names.gallery2"),
                        });
                        chartData.name = chartCategory;
                        chartData.data = charts;
                        options = {
                            names: labels,
                            colors: colors,
                            title: me.translate.__A('site.widget.' + chartCategory)
                        };
                        chartData.setOptions(options);
                        me.charts.push(chartData);
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        me.chartLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    WidgetReportComponent.prototype.getList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, _a, total, stats;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        me = this;
                        me.countLoader = true;
                        return [4 /*yield*/, me.siteService.widget.stats(me.filter.filterParams).toPromise()];
                    case 1:
                        _a = _b.sent(), total = _a.total, stats = _a.stats;
                        me.totalCount = total;
                        me.stats = stats;
                        me.countLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return WidgetReportComponent;
}(BaseComponent));
export { WidgetReportComponent };
